<ion-header>
  <ion-toolbar color="secondary">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{informe.nombreCompleto}}</ion-title>
    @if (estado !== '') {
      <ion-buttons slot="end">
        <ion-button (click)="modalCtrl.dismiss('validar')">
          <ion-icon slot="icon-only" name="checkmark-circle"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
  <ion-toolbar color="tertiary">
    <ion-title>TRIMESTRE {{informe.trimestre}} CURSO {{informe.curso}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="main">
    <div class="item-divider">
      <p>En el aula y con sus compañeros</p>
    </div>
    <div class="item-text-wrap ion-padding">
      <quill-view [content]="informe.aula"></quill-view>
    </div>
    @if (informe.imagen1 && informe.imagen1 !== '') {
      <div class="kblab-flex ion-justify-content-center">
        <img [lazyLoad]="informe.imagen1" [defaultImage]="shared.LOADER" alt="imagen informe 1">
      </div>
    }
    <div class="item-divider">
      <p>En las actividades realizadas</p>
    </div>
    <div class="item-text-wrap ion-padding">
      <quill-view [content]="informe.actividades"></quill-view>
    </div>
    @if (informe.imagen2 && informe.imagen2 !== '') {
      <div class="kblab-flex ion-justify-content-center">
        <img [lazyLoad]="informe.imagen2" [defaultImage]="shared.LOADER" alt="imagen informe 2">
      </div>
    }
    <div class="item-divider">
      <p>Aspectos a reforzar en casa</p>
    </div>
    <div class="item-text-wrap ion-padding">
      <quill-view [content]="informe.casa"></quill-view>
    </div>
    @if (informe.imagen3 && informe.imagen3 !== '') {
      <div class="kblab-flex ion-justify-content-center">
        <img [lazyLoad]="informe.imagen3" [defaultImage]="shared.LOADER" alt="imagen informe 3">
      </div>
    }
  </div>
</ion-content>
